module.exports = {"pt-BR":{"components":{"editableTextAreaField":{"notifications":{"submit":{"failure":"Não foi possível realizar a edição."}}}}}}